import React from 'react';
import PropTypes from 'prop-types';
import { TableBody } from './../../../../../themes/table';

const Tbody = ({ children, ...rest}) => {
  return (
    <TableBody>
      { children }
    </TableBody>
  );
}

Tbody.propTypes = {
  children: PropTypes.node
};

export default Tbody;
